import { authorizeMe, axiosInstance, getAccessToken } from "./commonHeadApiLogic.js";

// wrapper already defined by you
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe();
    return await apiFunction(...args);
  } catch (error) {
    console.error("Error in API request:", error);
    throw error;
  }
};

// view gallery
// export async function getPhotoskeysbyidAPI(page, limit, bookingId = "", photographerId = "") {
//   return withAuthorization(async () => {
//     const response = await axiosInstance.get(
//      `/api/admins/datalinks?page=${page}&limit=${limit}&bookingId=${bookingId}&photographerId=${photographerId}`
//     );
//     return response;
//   });
// }




// export async function getImagesUsingKeysAPI(bookingId, key) {
//   return withAuthorization(async () => {
//     const response = await axiosInstance.get(`
//       /api/admins/stream/${bookingId}/*${key}`,
//       {
//         responseType: "blob",
//       }
//     );

//     const blobUrl = URL.createObjectURL(response.data);
//     return blobUrl;
//   });
// }

// export async function getImagesUsingKeysAPI(bookingId, key) {
//   return withAuthorization(async () => {
//     // const response = await axiosInstance.get(
//     //   `/api/admins/stream/${bookingId}/${key}`,
//     //   {
//     //     responseType: "blob",
//     //   }
//     // );

//     const token=getAccessToken()
//     const baseURL = process.env.REACT_APP_PHOTOGRAPHY_ADMIN_BASE_API_URL || "";
  
//   const encodedKey = key
//     .split("/")
//     .map(encodeURIComponent)
//     .join("/");

//     // const blobUrl = URL.createObjectURL(response.data);
//     // return blobUrl;
//     if(!token) return "";
//     return` ${baseURL}/api/admins/stream/${bookingId}/${encodedKey}?token=${encodeURIComponent(token)}`;
//   });
// }

export async function getAllGalleryImages(
  page,
  limit,
  bookingId = "",
  category = "",
  source = "",
  photographerId = ""
) {
  return withAuthorization(async () => {
    const params = { page, limit };
    if (category) params.category = category;
    if (source) params.source = source;
    if (photographerId) params.photographerId = photographerId;

    const response = await axiosInstance.get(
      `/api/admins/getArrayImages/${bookingId}`,
      { params }
    );
    return response;
  });
}

const normalizeGalleryZipParams = (params = {}) => {
  if (!Array.isArray(params.keys) || params.keys.length === 0) {
    return params;
  }

  return {
    ...params,
    keys: JSON.stringify(params.keys),
  };
};

export async function getGalleryZipLink(params) {
  return withAuthorization(async () => {
    const response = await axiosInstance.get("/api/admins/gallery-zip-link", {
      params: {
        ...normalizeGalleryZipParams(params),
        _t: Date.now(),
      },
    });
    return response;
  });
}

export async function requestGalleryZipLink(payload) {
  return withAuthorization(async () => {
    const response = await axiosInstance.post("/api/admins/gallery-zip-link", payload);
    return response;
  });
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/** Open a signed DigitalOcean Spaces / CDN URL directly in the browser. */
export function openCdnZipDownloadUrl(downloadUrl) {
  if (!downloadUrl) {
    throw new Error("Download link is not available.");
  }

  const anchor = document.createElement("a");
  anchor.href = downloadUrl;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

const getApiBaseUrl = () =>
  (process.env.REACT_APP_PHOTOGRAPHY_ADMIN_BASE_API_URL || axiosInstance.defaults.baseURL || "").trim();

export function triggerDirectZipDownload(url) {
  let frame = document.getElementById("gallery-zip-download-frame");
  if (!frame) {
    frame = document.createElement("iframe");
    frame.id = "gallery-zip-download-frame";
    frame.style.display = "none";
    document.body.appendChild(frame);
  }
  frame.src = url;
}

export function buildAdminDirectZipDownloadUrl(params = {}, { clientId, token, apiBaseUrl } = {}) {
  const authToken = token || getAccessToken();
  if (!authToken) {
    throw new Error("Authentication session expired. Please login again.");
  }

  const base = (apiBaseUrl || getApiBaseUrl()).replace(/\/$/, "");
  const keys = Array.isArray(params.keys) ? params.keys : null;

  if (keys?.length) {
    const qs = new URLSearchParams({
      bookingid: params.bookingId,
      keys: JSON.stringify(keys),
      token: authToken,
    });
    return `${base}/api/admins/downloadZiponFourtyPlus?${qs.toString()}`;
  }

  const qs = new URLSearchParams({
    bookingid: params.bookingId,
    clientId: clientId || "",
    photographerId: params.photographerId || "",
    category: params.category || "",
    source: params.source || "",
    token: authToken,
  });
  return `${base}/api/admins/downloadZip?${qs.toString()}`;
}

/** Download immediately: CDN if ready, otherwise direct zip stream (no polling). */
export async function downloadGalleryZip(params = {}, options = {}) {
  await authorizeMe();
  await requestGalleryZipLink(params).catch(() => {});

  const CDN_WAIT_ATTEMPTS = 25;
  const CDN_POLL_MS = 2000;

  for (let attempt = 0; attempt < CDN_WAIT_ATTEMPTS; attempt += 1) {
    try {
      const response = await getGalleryZipLink(params);
      const data = response?.data;
      if (data?.zipStatus === "completed" && data?.downloadUrl) {
        const fileCount = data.zipFileCount || 0;
        const packedCount = data.zipPackedCount ?? fileCount;
        if (fileCount > 0 && packedCount > 0) {
          openCdnZipDownloadUrl(data.downloadUrl);
          return { mode: "cdn" };
        }
      }
      if (data?.zipStatus === "failed") {
        break;
      }
    } catch (_) {
      // keep polling
    }

    if (attempt === 0 && options.onWaiting) {
      options.onWaiting("cdn");
    }

    await sleep(CDN_POLL_MS);
  }

  if (options.onWaiting) {
    options.onWaiting("direct");
  }

  const directUrl = buildAdminDirectZipDownloadUrl(params, options);
  triggerDirectZipDownload(directUrl);
  return { mode: "direct" };
}

/** Poll gallery-zip-link until Spaces/CDN URL is ready (no Node zip streaming). */
export async function waitForGalleryZipDownloadUrl(params, { onWaiting } = {}) {
  await requestGalleryZipLink(params).catch(() => {});

  for (let attempt = 0; attempt < 60; attempt += 1) {
    const response = await getGalleryZipLink(params);
    const data = response?.data;

    if (data?.zipStatus === "completed" && data?.downloadUrl) {
      return data.downloadUrl;
    }

    if (data?.zipStatus === "failed") {
      throw new Error(data?.message || "ZIP preparation failed. Please try again.");
    }

    if (attempt === 0 && onWaiting) {
      onWaiting();
    }

    await sleep(attempt < 5 ? 2000 : 3000);
  }

  throw new Error("ZIP is still preparing. Please wait 1–2 minutes and try again.");
}

/** Queue/prepare ZIP on CDN, poll until ready, then download from CDN directly. */
export async function downloadGalleryZipFromCdn(params, options = {}) {
  // 1. Validate files exist and trigger background CDN worker.
  // This await prevents rapid double-clicks that abort the stream, and catches "No files" errors!
  await requestGalleryZipLink(params);

  // 2. Instantly trigger native streaming download (browser download manager)
  // This bypasses popup blockers perfectly because it uses a hidden iframe!
  const directUrl = buildAdminDirectZipDownloadUrl(params, options);
  triggerDirectZipDownload(directUrl);
  return directUrl;
}

export async function downloadFullZip(payload) {
  return withAuthorization(async () => {
    const response = await axiosInstance.post(
      "/api/admins/downloadZip",
      payload,
      {
        responseType: "blob",
        timeout:600000 // 10 min
      }
    );
    return response;
  });
}

export async function downloadSelectedImages(payload) {
  return withAuthorization(async () => {
    const response = await axiosInstance.post(
      "/api/admins/downloadZiponFourtyPlus",
      payload,
      {
        responseType: "blob",
        timeout:600000 // 10 min
      }
    );
    return response;
  });
}

export async function downloadSingleImage(payload) {
  return withAuthorization(async () => {
    const response = await axiosInstance.post(
      "/api/admins/downloadSingleFile",
      payload,
      {
        responseType: "blob",
        timeout:120000 // 10 min
      }
    );
    return response;
  });
}


export async function deleteSingleImage(payload) {
  return withAuthorization(async () => {
    const response = await axiosInstance.post(
      "api/admins/deleteSingleFile",
      payload
    );
    return response;
  });
}


export async function deleteSelectedImages(payload) {
  return withAuthorization(async () => {
    const response = await axiosInstance.post(
      "/api/admins/deleteMultipleFiles",
      payload
    );
    return response;
  });
}



